import Vue from 'vue';

import { CurrencyNumberFormat } from '@/share/Util/NumberFormat';

Vue.filter('formatPrice', (value: number) => {
  if (!value && value !== 0) return '';

  return CurrencyNumberFormat().format(value);
});
